export const getUser = (state) => state.userState.user
export const getUserLoading = (state) => state.userState.isLoading
export const getUserError = (state) => state.userState.err
export const getUserStatus = (state) => state.userState.status
export const getChangeUserInfoOpened = (state) => state.userState.isChangeUserInfoOpened